import type { User, MyAffiliate } from 'types'
import { createRequestInstance } from '../'

const FORMS_URL = import.meta.env.VITE_FORMS_URL || ''
const WAVIER_FORM_ID = import.meta.env.VITE_WAVIER_FORM_ID || ''
const APN_TOS_FORM_ID = import.meta.env.VITE_APN_TOS_FORM_ID || ''

const request = createRequestInstance({
  baseURL: FORMS_URL,
})

type ProgrammingWaiverBody = {
  agreeToWaiver: boolean
  software: string
  numberOfMembers: number
  inPerson: boolean
  currentProgramming: string
}

export async function submitProgrammingWaiver({
  data,
  user,
  affiliate,
}: {
  data: ProgrammingWaiverBody
  user: User
  affiliate: MyAffiliate
}) {
  const { software, numberOfMembers, inPerson, currentProgramming } = data

  const response = await request.post(WAVIER_FORM_ID, {
    agree_to_waiver: true,
    in_person: Boolean(inPerson),
    current_programming: currentProgramming,
    lor_email: user.email,
    lor_userid: String(user.id),
    num_members: String(numberOfMembers),
    workout_software: software,
    affiliate_id: String(affiliate?.affiliateId),
    group_id: String(affiliate?.groupId),
    affiliate_name: affiliate?.affiliateName,
  })

  return response.data
}

type APNTermsOfServiceBody = {
  name: string
  email: string
  agreeToTos: boolean
}

export async function submitAPNTermsOfService(data: APNTermsOfServiceBody) {
  const { name, email, agreeToTos } = data
  const response = await request.post(APN_TOS_FORM_ID, {
    name,
    email,
    agree_to_tos: agreeToTos,
  })

  return response.data
}
